import { TrackableButton } from '@components/TrackableButton/TrackableButton'
import { useOpenable } from '@hooks/base/useOpenable'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ContactUsModal } from './ContactUsModal'

interface ContactUsButtonProps {
	variant?: 'button' | 'link'
}

const ContactUsButton = ({ variant = 'button' }: ContactUsButtonProps) => {
	const { t } = useTranslation()
	const [isOpen, open, close] = useOpenable(false)

	const handleLinkClick = useCallback(
		(event: React.MouseEvent<HTMLAnchorElement>) => {
			event.preventDefault()
			open()
		},
		[open]
	)

	return (
		<>
			{variant === 'link' ? (
				// eslint-disable-next-line jsx-a11y/anchor-is-valid
				<a href="" onClick={handleLinkClick}>
					{t('button.contactUs')}
				</a>
			) : (
				<TrackableButton
					eventText="Contact Us"
					variant="contained"
					onClick={open}
				>
					{t('button.contactUs')}
				</TrackableButton>
			)}
			<ContactUsModal open={isOpen} onClose={close} />
		</>
	)
}

export { ContactUsButton }
